<template>
  <BaseTemplate :currentUser="currentUser">
    <Title eng="CONFIRMATION" :jpn="t('購入内容確認')" />
    <div class="leaf_box">
      <div class="product_title">
        <div class="label">{{t('購入商品名')}}</div>
        <div class="pack_name">{{currentPack.name}}</div>
    </div>
      <div class="confirm-buy-product">
        <ProductBanner
          v-if="currentPack"
          :packItem="currentPack"
          :showDetail="true"
        />
        <div class="message_area">
          <BorderArea class="border_area">
            <div class="areas">
              <span>{{t('消費ポイント')}}</span>
              <span v-if="packPoint" class="text">
                <span class="point">{{packPoint | comma}}</span>
                {{t('を消費し')}}
              </span>
              <span class="text">
                <span class="buy-count">{{$route.query.buyCount}}</span>
                {{t('回ガチャを引く')}}
              </span>
            </div>
          </BorderArea>

          <BorderArea class="border_area bg_black">
            <div class="areas">
              <span>{{t('所持ポイント')}}</span>
              <span v-if="packPoint" class="text m1">
                <span v-if="currentUser" class="point">{{currentUser.point | comma}}</span>
              </span>
              <i class="far fa-arrow-right"></i>
              <span class="text">
                <span v-if="currentUser && packPoint" class="point red_mode">
                  {{(currentUser.point - packPoint) | comma}}
                </span>
              </span>
            </div>
          </BorderArea>
          <hr>
          <div class="last_area">
            <span class="text confirm">{{t('よろしいですか？')}}</span>
            <div class="button-area">
              <BlackGradationButton
                class="square-button"
                :text="t('はい')"
                @handleSquareBtnClick="buyPack"
              />
              <div class="back_button" @click="goToBuyProduct">{{t('商品ページに戻る')}}</div>
              <SquareButton
                class="square-button"
                :text="t('いいえ')"
                :isSub="true"
                @handleSquareBtnClick="goToBuyProduct"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  separateCharacterNumber,
} from '@/common/util/format';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ProductBanner from '@/components/molecules/ProductBanner.vue';
import BorderArea from '@/components/atoms/BorderArea.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';

export default {
  name: 'ConfirmBuyProduct',
  mixins: [t],

  components: {
    BaseTemplate,
    ProductBanner,
    BorderArea,
    BlackGradationButton,
    Title,
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentPack: 'pack/currentPack',
      buyPackResult: 'pack/buyPackResult',
    }),
    packPoint() {
      if (this.currentPack) {
        return this.$route.query.buyCount * this.currentPack.point;
      }
      return 0;
    },
  },

  created() {
    const { packId } = this.$route.query;
    this.$store.dispatch('pack/setCurrentPack', { packId });
  },

  methods: {
    goToBuyProduct() {
      const query = {
        packId: this.$route.query.packId,
      };
      this.$router.push({ path: '/pack-detail', query });
    },
    buyPack() {
      (async () => {
        await this.$store.dispatch('pack/buyPack');
        const { buyPackResult } = this;
        const isSuceess = buyPackResult.state === 200 && buyPackResult.result === '1';
        if (isSuceess) {
          this.$store.dispatch('pack/clearBuyPackResult');
          this.$router.push('/gacha-animation');
        } else {
          const { count } = buyPackResult.errors;
          const query = {
            packId: this.$route.query.packId,
            errorMessageCount: count,
          };
          // this.$router.push({ path: '/buy-product', query });
          this.$router.push({ path: '/pack-detail', query });
        }
      })();
    },
  },
};
</script>

<style lang="scss" scoped>
.product_title {
  text-align: center;
  color: $white;
  margin-bottom: 20px;
  .label {
    font-size: 14px;
  }
  .pack_name {
    font-size: 30px;
    font-weight: bold;
  }
}
.leaf_box {
  max-width: 1000px;
  margin: 0 auto;
  align-items: center;
  .text {
    font-size: 14px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .confirm-buy-product {
    width: 680px;
    margin: auto;
    .message_area {
      margin-top: 60px;
      padding: 0 10px;
      color: $white;
      .pack_name_area {
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
        .left_area {
          width: 200px;
        }
        .pack_name {
          font-weight: 700;
          color: $yellow
        }
      }
      .border_area {
        width: 100%;
        margin-bottom: 20px;
        &.bg_black {
          background-color: $black;
          border: none;
        }
        .areas {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 0;
          .buy-count {
            font-weight: bold;
            font-size: 28px;
            color: $yellow;
            margin-right: 10px;
          }
          .m1 {
            margin-left: 30px;
          }
        }
      }
    }
  }
}
.point {
  font-weight: bold;
  font-size: 28px;
  display: inline-flex;
  align-items: center;
  margin-right: 10px;

  &:before {
    content: "P";
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    color: $deepGray;
    background-color: $white;
    font-weight: normal;
    font-size: 18px;
    font-weight: bold;
    border-radius: 100px;
    margin-right: 5px;
  }
}
.fa-arrow-right {
  margin: 0 10px;
}
.red_mode {
  color: $yellow;
  &:before {
    background-color: $yellow;
  }
}
hr {
  border:none;
  background-color: $deepGray;
  height: 1px;
  margin: 30px -10px;
}
.last_area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 40px;
  margin-bottom: 40px;
  .confirm {
    font-size: 14px;
    font-weight: 700;
    text-align: center;
  }
  .square-button {
    margin: 20px auto 20px auto;
    width: 240px;
    font-size: 24px;
  }
  .back_button {
    text-align: center;
    color: $white;
    text-decoration: underline;
    font-size: 14px;
    cursor: pointer;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .leaf_box {
    margin: 0 10px;
    .confirm-buy-product {
      width: 100%;
    }
  }
  .pack_name_area {
    flex-direction: column;
    .left_area {
      text-align: center;
      width: 100%;
      margin-bottom: 10px;
    }
  }
  .areas {
    flex-direction: column;
  }
  .pack_name {
    display: flex;
    flex-direction: column;
    align-items: center;
    .fa-arrow-right {
      transform: rotate(90deg);
    }
  }
  .m1 {
    margin-left: 0!important;
  }
  .fa-arrow-right {
    transform: rotate(90deg);
  }
}
</style>
